import { FilterPage , ILoadTracker} from  "@/interfaces/insightsp2";
import React from "react";

export const InsightsContext = React.createContext({
    loading:false,
    setLoading: () => {},
    filterPage:null,
    setFilterPage:() => {},
    loadTracker:null
})

export interface IInsightsContext {
    loading:boolean,
    setLoading:(value:boolean) => void,
    filterPage:FilterPage,
    setFilterPage:(value:FilterPage) => void,
    loadTracker:ILoadTracker
}